//# sourceMappingURL=function.mjs.map
/// <reference types="./function.d.mts" />
export function tap(value, next) {
  next(value);
  return value;
}

export function constant(value) {
  return (_) => { return value; };
}

export function always(value) {
  return () => { return value; };
}

export function identity(value) {
  return value;
}

export function flip(fun) {
  return (a, b) => { return fun(b, a); };
}

export function compose(f, g) {
  return (data) => { return f(g(data)); };
}

export function then$(g, f) {
  return (data) => { return f(g(data)); };
}

export function call(a) {
  return a();
}

/**
 * Turn a function `fn (a) -> b` as `fn (a) -> Nil`.
 */
export function nillify(f) {
  return (value) => {
    f(value);
    return undefined;
  };
}
